export const AUTH_STATE_CHANGE = "auth_state_change";